const atcForm = document.querySelector('form[action="/cart/add"]');
const atcButton = document.querySelector('.product-form--atc-button');
if (atcButton) {
  atcButton.addEventListener('click', (event) => {
    event.preventDefault();    
    addItemToCart();
  });
}
  async function getShopifyCartItemQty() {
    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const cartData = await response.json();
      let totalQuantity = 0;
      for (let item of cartData.items) {
        return item.quantity;        
      }

      return totalQuantity;
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }
  function toggleAtcSpinner(show) {
    const atcBtn = document.querySelector('.product-form--atc-button');
    if (show) {
      atcBtn.classList.add('processing');
      atcBtn.setAttribute('disabled', 'disabled');
    }
    else {
      atcBtn.classList.remove('processing');
      atcBtn.removeAttribute('disabled');
    }
  }
  function showErrorMessage(message) {
    const siteHeader = document.querySelector('header.site-header');
    siteHeader.insertAdjacentHTML('beforeend',
      `<div class="message-banner--container message--error visible" role="alert" data-message-banner="">
        <div class="message-banner--outer">
          <div class="message-banner--inner" data-message-banner-content="">${message}</div>
          <button class="message-banner--close" type="button" aria-label="Close" data-message-banner-close="">      
            <svg class="icon-menu-close " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">          <title>Close icon</title>        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 7.73744L1.61872 12.6187L0.381283 11.3813L5.26256 6.50001L0.381283 1.61872L1.61872 0.381287L6.5 5.26257L11.3813 0.381287L12.6187 1.61872L7.73744 6.5L12.6187 11.3813L11.3813 12.6187L6.5 7.73744Z" fill="currentColor"></path>    </svg>                                                
          </button>
        </div>
      </div>`
    );
    // const errMsgContainer = document.querySelector('.message-banner--container');
    // const errMsgInner = errMsgContainer.querySelector('.message-banner--inner');
    // errMsgContainer.classList.add('message--error','visible');
    // errMsgInner.textContent = message;
  }
  async function updateCartIconQty() {
    const currentCartItemQty = await getShopifyCartItemQty();
    console.log('currentCartItemQty',currentCartItemQty);
    const cartCount = document.querySelector('.site-header-cart--count');
    cartCount.dataset.headerCartCount = currentCartItemQty;
  }
  function addItemToCart() {
    toggleAtcSpinner(true);
    const productIdElement = (document.querySelector('input[name="id"]')) ? document.querySelector('input[name="id"]') : document.querySelector('select[name="id"]');
    const productVariantId = parseInt(productIdElement.value);
    const quantity = parseInt(document.querySelector('input[name="quantity"]').value);    
    let formData = { 'items': [
        {
          'id': productVariantId,
          'quantity': quantity
        }
      ] };
      
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      console.log('add to cart success data', data);
      if (data.status >= 300) {
        showErrorMessage(data.message);
        updateCartIconQty();
      }
      else {
        window.location.href = '/cart';
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      var response = JSON.parse(error.responseText);
      showErrorMessage(response.message);
    })
    .finally((response) => {
      toggleAtcSpinner(false);
    });
  }